import React from 'react';
import PropTypes from 'prop-types';
import './styles/CircularProgress.css';


const CircularProgress = ({ 
  percentage, 
  size = 120, 
  strokeWidth = 8,
  color = '#EAB308',
  showLabels = false
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="circular-progress-container">
      <div className="circular-progress">
        <svg width={size} height={size}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            className="circular-progress-bg"
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            className="circular-progress-bar"
          />
        </svg>
        <div className="circular-progress-text">
          <span>{percentage}%</span>
        </div>
      </div>
      
      {showLabels && (
        <div className="progress-labels">
          <span className="progress-label top">75%</span>
          <span className="progress-label right">100%</span>
          <span className="progress-label bottom">25%</span>
          <span className="progress-label left">0%</span>
        </div>
      )}
    </div>
  );
};

CircularProgress.propTypes = {
  percentage: PropTypes.number.isRequired,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  color: PropTypes.string,
  showLabels: PropTypes.bool,
};

export default CircularProgress;